var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.332 0.03004C14.6937 -0.0991567 15.0484 0.208419 14.9957 0.569825L14.978 0.647954L10.978 13.648C10.8816 13.9612 10.5213 14.0916 10.2507 13.9345L10.1794 13.8845L6.71727 10.9894L4.85368 12.8545C4.56023 13.1479 4.07231 12.9744 4.00735 12.5884L4.00013 12.5026L3.98719 8.72393L0.201326 5.90181C-0.0653926 5.70302 -0.0579242 5.32339 0.169524 5.12467L0.244304 5.07084L0.331957 5.03004L14.332 0.03004ZM13.7293 1.30594L1.54676 5.65655L4.49302 7.85354L11.2095 3.09403C11.7055 2.74247 12.2296 3.38578 11.9095 3.79551L11.8551 3.85506L11.7893 3.90883L5.32751 8.52262L10.2431 12.6347L13.7293 1.30594ZM4.99585 11.2962L4.9903 9.69792L5.79214 10.5003L4.99585 11.2962Z",
    fill: "#1B66F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.93aceba081f139c7d82959ce2fe92971.svg";
export { ForwardRef as ReactComponent };